import Nullstack from 'nullstack';
export default function IconNumbers({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-numbers",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 10v-7l-2 2"
  }), "   ", Nullstack.element("path", {
    d: "M6 16a2 2 0 1 1 4 0c0 .591 -.601 1.46 -1 2l-3 3.001h4"
  }), "   ", Nullstack.element("path", {
    d: "M15 14a2 2 0 1 0 2 -2a2 2 0 1 0 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 10h3"
  }), " ");
}